import messages from "@smartmixin/i18n/dist/translations/en.json";

export default messages;
